<template>
  <span>
    <!-- ▼メッセージ作成-->
    <seminar-entry-message-register-form
      v-show="!isSendable"
      ref="seminarEntryMessageRegisterForm"
      v-model="message"
      :entry-ids="entryIds"
      @filledOut="onFilledOut"
    />
    <!-- ▲メッセージ作成-->
    <!-- ▼メッセージ確認-->
    <seminar-entry-message-register-confirm
      v-show="isSendable"
      :message="message"
      @back="isSendable = false"
      @submitted="onRegistered"
    />
    <!-- ▲メッセージ確認-->
  </span>
</template>

<script>
import SeminarEntryMessageRegisterForm from '@/components/molecules/SeminarEntryMessageRegisterForm'
import SeminarEntryMessageRegisterConfirm from '@/components/molecules/SeminarEntryMessageRegisterConfirm'
import _ from 'lodash'
import Indicator from '@/lib/indicator'

function createMessage (entryIds, subject, body) {
  return {
    entryIds: entryIds,
    subject: subject,
    body: body,
    isStatusChange: null,
    statusId: null
  }
}

export default {
  components: {
    SeminarEntryMessageRegisterForm,
    SeminarEntryMessageRegisterConfirm
  },
  props: {
    entryIds: {
      type: Array,
      required: true
    },
    body: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      message: createMessage(this.entryIds, this.subject, this.body),
      isSendable: false,
      isIncludedWithdrawalUser: false
    }
  },
  watch: {
    body (val) {
      this.$set(this.message, 'body', val)
    },
    subject (val) {
      this.$set(this.message, 'subject', val)
    },
    entryIds: {
      handler () {
        this.fetchCurrentStatus()
      }
    }
  },
  created () {
    this.entryIds.length && this.fetchCurrentStatus()
  },
  methods: {
    onFilledOut () {
      this.isSendable = true
    },
    onRegistered () {
      this.chunkSend()
    },
    chunkSend () {
      const chunkEntryIds = _.chunk(this.message.entryIds, 50)
      this.send(chunkEntryIds)
    },
    send (chunkEntryIds) {
      const entryIds = chunkEntryIds.shift()
      // リクエストの形に整形
      const requestParam = this.requestMessageParam(entryIds)
      Indicator.emitShow()
      this.$http.secured.post('/seminar/entry/message/send', requestParam).then((response) => {
        // 退会者がいた場合に更新
        response.data.isIncludedWithdrawalUser && this.$set(this, 'isIncludedWithdrawalUser', true)
        if (_.isEmpty(chunkEntryIds)) {
          if (this.message.isStatusChange) {
            this.$toasted.global.success({ message: 'ステータスを更新しました。' })
          }
          if (this.$route.params.entryId) {
            this.$toasted.global.success({ message: '応募者にメッセージを送信しました。' })
            this.isSendable = false
            this.$emit('registered')
          } else {
            // 一括送信の場合
            this.$toasted.global.success({ message: '応募者にメッセージを一括送信しました。' })
            this.$router.push('/seminar_entries')
          }
          if (this.isIncludedWithdrawalUser) {
            this.$toasted.global.success({ message: '退会者が含まれていました。退会者には送信していません。' })
          }
          this.reset()
          Indicator.emitHide()
        } else {
          this.send(chunkEntryIds)
        }
      }).catch(() => {
        Indicator.emitHide()
      })
    },
    fetchCurrentStatus () {
      const entryId = this.entryIds[0]
      this.$http.secured.get(`/seminar/entries/${entryId}/current_status`).then(response => {
        this.$set(this.message, 'statusId', response.data.statusId)
      })
    },
    reset () {
      this.$set(this, 'message', createMessage(this.entryIds, '', ''))
      this.$set(this, 'isIncludedWithdrawalUser', false)
      this.fetchCurrentStatus()
      this.$refs.seminarEntryMessageRegisterForm.reset()
    },
    requestMessageParam (entryIds) {
      const requestParam = _.cloneDeep(this.message)
      requestParam.entryIds = entryIds || []
      return requestParam
    }
  }
}
</script>
